export const Role = Object.freeze({
  guest: "guest",
  insight: "insight",
  indicator: "indicator",
  employee: "employee",
  admin: "admin",
  superAdmin: "superAdmin",
});
